<template>
  <div>
    <default-modal
      ref="box"
      :title="title"
      :modalWidth="600"
      :confirmBtn="false"
      :cancleBtn="true"
      :cancleTxt="`关闭`"
    >
      <div class="content">
        <div class="_blue">
          我要接收别人通行证转移来的网吧ID（服务器）
        </div>
        <div class="_con">
          <p>
            1、请点击下方的“获取接收码”按钮，然后将接收码提供给转出方。
          </p>
          <p>2、将接收码提供给转出方，让其进行网吧转移操作。</p>
          <p>
            注：转出方将网吧ID（服务器）转移完成后，你可以为员工新建员工账号，并将网吧关联给员工，员工使用新的账号登录即可管理网吧。
          </p>
        </div>
        <div class="receiveCode">
          <input
            type="text"
            readonly
            v-model="receiveCode"
            placeholder="点击获取接收码"
          />
          <a
            href="#"
            @click.prevent="getReceiveCode"
            class="blue-btn"
          >获取接收码</a>
        </div>
      </div>
    </default-modal>
  </div>
</template>

<script>
import DefaultModal from "_c/modals/defaultModal";
import { getReceiveCode } from "@/requests/bar";
export default {
  name: "barModals",
  components: {
    DefaultModal
  },
  data() {
    return {
      title: "接收网吧",
      receiveCode: ""
    };
  },
  computed: {},
  mounted() {
    window.$modal.receiveBarModal = {};
    window.$modal.receiveBarModal.show = () => {
      this.init();
    };
    //监听键盘按键事件
    let self = this;
    this.$nextTick(function () {
      document.addEventListener('keyup', function (e) {
        //此处填写你的业务逻辑即可
        if (e.keyCode == 27) {
          self.$refs.box.hide();
        }
      })
    })
  },
  methods: {
    init() {
      this.receiveCode = "";
      this.$refs.box.show();
    },
    // 获取接收码
    async getReceiveCode() {
      let res = await getReceiveCode();
      if (res.code == 200) {
        this.receiveCode = res.data;
      } else {
        this.$refs.box.setWrong(res.msg);
      }
    }
  }
};
</script>

<style lang="scss" scoped>
@import "_style/msgbox/_msgBox.scss";
@import "_style/_color.scss";

.content {
  padding: 0 20px;
  margin-top: 10px;

  ._blue {
    font-size: 14px;
    color: $blue;
    margin-bottom: 20px;
    text-align: left;
  }
  ._con {
    p {
      line-height: 20px;
      color: $gray-word;
      text-align: left;
    }
  }
  .receiveCode {
    margin: 25px 0 10px 0;
    input {
      width: 200px;
      height: 30px;
      border: 1px solid rgba(230, 230, 230, 1);
      padding-left: 10px;
    }
    a {
      width: 100px;
      height: 30px;
      padding: 0;
      text-align: center;
      line-height: 30px;
      color: #fff;
    }
  }
}
</style>
